import * as React from "react";
import { StoresContext } from "./StoresProvider";

export function useStore<T>(sym: symbol) {
  return React.useContext(StoresContext).get(sym) as T;
}
